import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { WizardStep } from '../../models';

@Component({
  selector: 'app-wizard-stepper',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './wizard-stepper.component.html',
  styleUrl: './wizard-stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardStepperComponent {
  readonly steps = input.required<WizardStep[]>();
  readonly currentStep = input.required<number>();
  readonly isViewMode = input<boolean>(false);

  readonly stepClick = output<number>();

  readonly progressWidth = computed(() => {
    const current = this.currentStep();
    const total = this.steps().length;
    if (total <= 1) return '0%';
    return `${(current / (total - 1)) * 100}%`;
  });

  getStepClass(step: WizardStep): Record<string, boolean> {
    const current = this.currentStep();
    return {
      'step--active': step.index === current,
      'step--completed': step.index < current,
      'step--pending': step.index > current,
      'step--valid': step.isValid,
      'step--invalid': !step.isValid && step.index <= current
    };
  }

  getStepIcon(step: WizardStep): string {
    if (step.index < this.currentStep()) {
      return 'pi pi-check';
    }
    return '';
  }

  canClickStep(step: WizardStep): boolean {
    return step.index < this.currentStep() || step.isCompleted;
  }

  onStepClick(step: WizardStep): void {
    if (this.canClickStep(step)) {
      this.stepClick.emit(step.index);
    }
  }
}
